import React, { FC } from 'react'
import { navigate } from 'gatsby'
import { FormControl, Select, MenuItem } from '@material-ui/core'

import StylesModule from 'components/lv1/selectLanguage.module.scss'

export interface selectLanguageProps {
  language: {
    select: string
    japanese: string
    english: string
  }
  page?: string
}

const selectLanguage: FC<selectLanguageProps> = ({ language, page }) => {
  const pagePath: string = page || ''
  function handleChange(event: React.ChangeEvent<{ value: unknown }>) {
    switch (event.target.value) {
      case 'japanese':
        navigate(`/ja${pagePath}/index.html`)
        break
      case 'english':
        navigate(`/en${pagePath}/index.html`)
        break
    }
  }
  return (
    <div className={StylesModule.selectLanguage}>
      <FormControl
        classes={{
          root: StylesModule.formControl,
        }}
      >
        <Select
          value={language.select}
          onChange={handleChange}
          displayEmpty
          className={StylesModule.selectControl}
          inputProps={{ 'aria-label': language.select }}
          classes={{
            root: StylesModule.selectControl,
            icon: StylesModule.icon,
          }}
          color="secondary"
        >
          <MenuItem value={language.select}>{language.select}</MenuItem>
          <MenuItem value="japanese">{language.japanese}</MenuItem>
          <MenuItem value="english">{language.english}</MenuItem>
        </Select>
      </FormControl>
    </div>
  )
}

export default selectLanguage
